import { Typography, Tabs, Alert, Card } from 'antd';
import { TagOutlined } from '@ant-design/icons';
import MarketIndicatorMapper from '../MarketIndicatorMapper';
import MarketLabelsTab from '../MarketLabelsTab';
import MarketIndicatorMethodologyMapper from '../MarketIndicatorMethodologyMapper';

const { Title, Text } = Typography;

function MarketIndicatorMitigationMapper() {
  return (
    <div style={{ padding: 24, background: '#f5f5f5', minHeight: '100vh', boxSizing: 'border-box' }}>
      <div
        style={{
          marginBottom: 16,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          gap: 16,
          flexWrap: 'wrap',
        }}
      >
        <div style={{ flex: '1 1 auto' }}>
          <Title level={3} style={{ marginBottom: 0 }}>
            <TagOutlined style={{ marginRight: 8 }} />
            Market labels Mapper
          </Title>
          <Text type="secondary">
            Map registry methodologies to market labels.
          </Text>
        </div>
        <Alert
          type="info"
          showIcon
          closable
          message="Please note that changes saved here won't appear on the platform immediately. They will be applied during the next automatic registry sync, which runs every Saturday."
          style={{ width: '50%', flexShrink: 0 }}
        />
      </div>
      <Card
        bordered={false}
        style={{ borderRadius: 10, boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}
      >
        <Tabs
          defaultActiveKey="market-indicator"
          type="card"
          items={[
            {
              key: 'methodology-market-indicator',
              label: 'Harmonized Methodology Pre-Mapping',
              children: <MarketIndicatorMethodologyMapper />,
            },
            {
              key: 'market-indicator',
              label: 'Project Id Level mapping',
              children: <MarketIndicatorMapper />,
            },
            {
              key: 'market-labels',
              label: 'Market labels Metadata',
              children: <MarketLabelsTab />,
            },
          ]}
        />
      </Card>
    </div>
  );
}

export default MarketIndicatorMitigationMapper;
